<template>
  <div class="layout-body">
    <div class="layout-header-bar">
      <div class="head-logo">
        <img src="@assets/img/guoyao-logo.png" alt="云展台" @click="$router.push('/exhibition/index/home')" class="f-csp"/>
      </div>
      <div class="head-right">
        <div class="head-btn" @click="$router.push('/exhibition/index/home')">返回</div>
      </div>
    </div>
    <div class="layout-box">
      <div class="register-form">
        <div class="rf-title">关联展会</div>
        <Form ref="formInline" label-position="right" :label-width="150" @submit.native.prevent>
          <FormItem label="选择展会：">
            <Input type="text" v-model="exName" @click.native="add = true" readonly>
              <i class="icon iconfont icon-daohang1" slot="suffix"></i>
            </Input>
          </FormItem>
        </Form>
      </div>
    </div>
    <div class="layout-box z-top">
      <exhibition-join-info :exhibition="exhibition" />
    </div>
    <!-- 选择展会 -->
    <exhibitionChoiceModal :show="add" @close="add=false" @change="setEx" />
  </div>
</template>

<script>
import exhibitionChoiceModal from "./components/exhibition-choice-modal";
import exhibitionJoinInfo from "./components/exhibition-join-info";
import { validator } from "@/other/validator";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "exhibition-register-company",
  data() {
    return {
      loading: false,
      showModel: false,
      add: false,
      exName: "",
      exhibition: null
    };
  },
  components: { exhibitionJoinInfo, exhibitionChoiceModal },
  created() {
    document.title = "注册 - 关联展会";
    this.getDefaultEx();
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition", 
      setJoinEx: "companyModule/setJoinEx",
    }),
    ...mapActions({
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
    }),
    setEx(item) {
      this.add = false; 
      if (item) {
        this.setExhibition(item);
        this.exName = item.name;
        this.exhibition = item;
      }
    },
    async getDefaultEx() {
      let ex = null;
      let res = await this.getDefaultJoinExhibition(this.company.id);
      if(res && res.exhibitionId) {
        this.setJoinEx(res);
        ex = await this.getExhibitionById(res.exhibitionId);
      }
      if (ex && ex.id) { 
        this.setEx(ex);
      } else {
        // this.$Message.warning(`暂未关联展会！`);
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.layout-box {
  padding-bottom: 20px;
  background: #fff;
  &.z-top {
    background: #fff;
    border-top: 10px solid #fafafa;
  }
}
.register-form {
  font-size: 14px;
  width: 650px;
  margin: 0 auto;
  .rf {
    &-title {
      font-size: 20px;
      color: #333;
      padding: 60px 0 44px;
      text-align: center;
    }
  }
  .form-code-item {
    .ivu-btn {
      margin-left: 10px;
      width: calc(100% - 10px);
    }
  }
  .form-tip-info {
    color: #1890ff;
    cursor: pointer;
  }
}

.layout-body {
  height: 100%;
  background: #fff;
}
.layout-header-bar {
  display: flex;
  background: #002140;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.head-logo {
  height: 64px;
  padding-top: 16px;
  padding-left: 19px;
}
.head-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-btn {
  font-size: 18px;
  color: #ededed;
  padding-right: 45px;
  display: inline-block;
  cursor: pointer;
}
</style>